// extracted by mini-css-extract-plugin
module.exports = {"same-para":"Policy_same-para__3lcmE","policy-container":"Policy_policy-container__17FsQ","container":"Policy_container__3IXdH","ol-container":"Policy_ol-container__3Kvb8"};